if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.bindEvents();
      }

      bindEvents() {
        const main_wapper = this.querySelector('.swiper-main-wrapper');
        const product_hendle = this.getAttribute('data-product-handle');
        const this_obj = this;
        const gridItemWidth = this.getAttribute('data-grid-item-class');
        const rowOf = this.getAttribute('data-row-of');
        const images_size = this.getAttribute('data-image-sizes');
        const enable_quick_add = this.getAttribute('data-quick_add_btn');
        const sliderOptions = this_obj.getAttribute('data-slider-options');
        let promises = [];

        // Collect valid recently viewed product handles
        Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
          if (handle && handle !== 'undefined' && product_hendle !== handle) {
            promises.push(getProductInfo(handle));
          }
        });

        // If no products to show, display placeholder message
        if (promises.length === 0) {
          const placeholder = document.createElement('div');
          placeholder.className = 'recently-viewed-placeholder';
          placeholder.innerHTML = `
            <p>You haven't viewed any products yet. Browse our
            <a href="/collections/all">best-sellers</a> to get started!</p>`;
          main_wapper.appendChild(placeholder);
          return;
        }

        // Otherwise, fetch and render recently viewed products
        Promise.all(promises).then(function (productsHTML) {
          const container = document.createElement('div');
          container.className = 'swiper recently-viewed-swiper';

          const wrapper = document.createElement('div');
          wrapper.className = 'swiper-wrapper';

          productsHTML.forEach(function (productHTML) {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            slide.innerHTML = productHTML;
            wrapper.appendChild(slide);
          });

          container.appendChild(wrapper);
          main_wapper.appendChild(container);

          if (sliderOptions) {
            const slideroptionConfig = JSON.parse(sliderOptions);
            const recommedndationSlider = new Swiper(".recently-viewed-swiper", slideroptionConfig);
          }
        });

        // Fetch product info (from theme cache or via AJAX)
        function getProductInfo(handle) {
          return new Promise(function (resolve, reject) {
            if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
              resolve(theme.recentlyViewed.productInfo[handle]);
            } else {
              fetch('/products/' + handle + '?view=card')
                .then(function (response) { return response.text(); })
                .then(function (product) { resolve(product); })
                .catch(reject);
            }
          });
        }
      }
    }
  );

  // Check iWish integration
  try {
    if (typeof iWish !== "undefined") {
      setTimeout(function () {
        iWish.checkIwishColl();
      }, 3000);
    }
  } catch (error) {
    // console.log(error);
  }
}
